// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"12534028","37":"8ab1cbbe","70":"95f8324d","189":"891b2a07","267":"2035519c","511":"a15a1d48","528":"d12c0e19","643":"b30b2234","671":"def4fd27","787":"3e726b03","894":"52c596e4","942":"cfd8f222"}[chunkId] + ".chunk.js";
};